
export function savePayment(payment) {
    return function (dispatch, getStore) {
        dispatch({type: "SET_PAYMENT", payment: payment});
    }
}

export function clearPayment(payment) {
    return function (dispatch, getStore) {
        dispatch({type: "CLEAR_PAYMENT", payment: payment});
    }
}